// packages/world-model/src/traits/readable/index.ts

export { ReadableTrait } from './readableTrait';
export { ReadableBehavior } from './readableBehavior';
